import { render } from "./Dropdown.vue?vue&type=template&id=83078d18&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-83078d18"

export default script